import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { getZendeskScriptUrl } from "../../../config/config";
import {
  useVendorConfigPlugin,
  getVendorConfig,
  type Brand,
} from "../vendorConfig";

const initZendeskAtom = atom<Brand | null>(null);

export const useInitZendesk = () => {
  const [scriptLoaded, setScriptLoaded] = useAtom(initZendeskAtom);
  const vendorPlugin = useVendorConfigPlugin();
  const getBrandKey = (): "smsb" | "tpg" | "mm" | null => {
    if (vendorPlugin?.isBrandSMSB()) return "smsb";
    if (vendorPlugin?.isBrandTPG()) return "tpg";
    if (
      vendorPlugin?.isBrandMM() ||
      vendorPlugin?.isBrandSE() ||
      vendorPlugin?.isBrandDirectSMS() ||
      vendorPlugin?.isBrandMessageNet() ||
      vendorPlugin?.isBrandMobiPost() ||
      vendorPlugin?.isBrandSMSC() ||
      vendorPlugin?.isBrandStreetData() ||
      vendorPlugin?.isBrandWholeSale()
    )
      return "mm";
    return null;
  };
  const brandKey = getBrandKey();
  const config = brandKey ? getVendorConfig(brandKey) : null;

  useEffect(() => {
    if (config && scriptLoaded !== config.brand) {
      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src = `${getZendeskScriptUrl()}${config.zendeskKey}`;
      script.type = "text/javascript";
      script.async = true;

      script.onload = () => setScriptLoaded(config.brand);
      script.onerror = () => console.error("Zendesk failed to load");

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
    return;
  }, [scriptLoaded, setScriptLoaded, config]);
};
